;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import { useFavorites as useFavoritesContext } from '../contexts/FavoritesContext';

// Re-export the context hook for convenience
export const useFavorites = useFavoritesContext;

// Custom hook for individual item favorite status
export const useItemFavorite = (itemId, itemType, itemData = {}) => {
    const {
        isFavorited,
        addFavorite,
        removeFavorite,
        totalCounts,
        getFavoriteCounts,
    } = useFavoritesContext();

    const favorited = isFavorited(itemId, itemType);
    const countKey = `${itemType}:${itemId}`;
    const count = totalCounts[countKey] || 0;

    const toggleFavorite = async () => {
        if (favorited) {
            await removeFavorite(itemId, itemType);
        } else {
            await addFavorite({
                id: itemId,
                type: itemType,
                title: itemData.title || '',
                slug: itemData.slug,
                image: itemData.image,
            });
        }
    };

    const loadCount = async () => {
        if (!(countKey in totalCounts)) {
            await getFavoriteCounts([countKey]);
        }
    };

    return {
        favorited,
        count,
        toggleFavorite,
        loadCount,
    };
};

// Custom hook for batch operations
export const useBatchFavorites = () => {
    const { getFavoriteCounts, totalCounts } = useFavoritesContext();

    const loadCounts = async items => {
        const itemKeys = items.map(item => `${item.type}:${item.id}`);
        const missingKeys = itemKeys.filter(key => !(key in totalCounts));

        if (missingKeys.length > 0) {
            await getFavoriteCounts(missingKeys);
        }
    };

    const getCounts = items => {
        const counts = {};
        items.forEach(item => {
            const key = `${item.type}:${item.id}`;
            counts[key] = totalCounts[key] || 0;
        });
        return counts;
    };

    return {
        loadCounts,
        getCounts,
    };
};

// Custom hook for favorites page/list
export const useFavoritesList = (type = null) => {
    const {
        favorites,
        getFavoritesByType,
        clearAllFavorites,
        removeFavorite,
        initialized,
    } = useFavoritesContext();

    const filteredFavorites = type ? getFavoritesByType(type) : favorites;

    const removeFavoriteById = async (itemId, itemType) => {
        await removeFavorite(itemId, itemType);
    };

    const clearFavorites = () => {
        clearAllFavorites();
    };

    return {
        favorites: filteredFavorites,
        allFavorites: favorites,
        removeFavorite: removeFavoriteById,
        clearAllFavorites: clearFavorites,
        isEmpty: filteredFavorites.length === 0,
        count: filteredFavorites.length,
        totalCount: favorites.length,
        initialized,
    };
};
